(function () {
  var SESSION_FLAG = 'eys-newsletter-just-subscribed';
  var POSTED_PATTERNS = ['customer_posted=true', 'contact%5Btags%5D=newsletter'];

  function urlHasPosted() {
    var u = window.location.href;
    for (var i = 0; i < POSTED_PATTERNS.length; i++) {
      if (u.indexOf(POSTED_PATTERNS[i]) >= 0) return true;
    }
    return false;
  }

  function cleanUrl() {
    try {
      var clean = location.href.split('?')[0];
      window.history.replaceState({}, document.title, clean);
    } catch (_) {}
  }

  function silenceGlozinToast() {
    // Glozin's returnMessageWhenSubmit shows a toast on customer_posted=true.
    // We replace the toast helper with a no-op so only our popup is visible.
    try {
      if (typeof window.showToast === 'function') {
        window._origShowToast = window.showToast;
        window.showToast = function () { /* suppressed by eys popup */ };
      }
    } catch (_) {}
  }

  function showSuccessInPopup(popupEl) {
    var fs = popupEl.querySelector('.newsletter-popup__form-state');
    var ss = popupEl.querySelector('.newsletter-popup__success-state');
    if (!fs || !ss) { return false; }
    fs.hidden = true;
    ss.hidden = false;
    return true;
  }

  function waitForPopupContent(callback, timeoutMs) {
    var deadline = Date.now() + (timeoutMs || 5000);
    var iv = setInterval(function () {
      // Tingle modal: .tingle-modal .newsletter-popup
      var popup = document.querySelector('.tingle-modal .newsletter-popup') || document.querySelector('.newsletter-popup');
      if (popup && popup.querySelector('.newsletter-popup__form-state')) {
        clearInterval(iv);
        callback(popup);
      } else if (Date.now() > deadline) {
        clearInterval(iv);
      }
    }, 100);
  }

  // ============ POST-SUBSCRIBE FLOW: show success state ============
  function handlePostSubscribe() {
    if (!urlHasPosted() && sessionStorage.getItem(SESSION_FLAG) !== '1') return;
    sessionStorage.removeItem(SESSION_FLAG);
    silenceGlozinToast();
    cleanUrl();

    // Force-open the newsletter-popup by calling its init() now (skip the 12s wait)
    var el = document.querySelector('newsletter-popup');
    if (el && typeof el.init === 'function') {
      // Clear the don't-show cookie so popup can open even after first subscribe
      document.cookie = 'newsletter_popup=; max-age=0; path=/';
      try { el.init(); } catch (e) { }
    }
    // Wait for popup content + tingle modal to render, then flip state
    waitForPopupContent(function (popup) {
      showSuccessInPopup(popup);
      // Now set the cookie so it doesn't re-open later
      document.cookie = 'newsletter_popup=1; max-age=2592000; path=/';
    }, 15000);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handlePostSubscribe);
  } else {
    handlePostSubscribe();
  }

  // ============ INTERCEPT BUTTON CLICK: just set the flag, then let form submit ============
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.section-newsletter-form__button, .newsletter-popup button[type=submit]');
    if (!btn) return;
    var form = btn.closest('form');
    if (!form) return;
    var inPopup = btn.closest('.newsletter-popup') || btn.closest('.tingle-modal');
    if (!inPopup) return;
    if (form.checkValidity && !form.checkValidity()) return; // browser shows native validation
    // Set the flag so even if URL params get lost, we know to show success on reload
    try { sessionStorage.setItem(SESSION_FLAG, '1'); } catch (_) {}
    // Don't preventDefault — let Shopify handle captcha + submission
  }, true);

  // ============ CLICK-TO-COPY ============
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.newsletter-popup__code'); if (!b) return;
    e.preventDefault();
    var c = b.getAttribute('data-eys-copy') || b.textContent.trim();
    if (!c) return;
    var tt = b.querySelector('.newsletter-popup__copied-tooltip');
    var show = function(){ if (tt){ tt.hidden=false; setTimeout(function(){ tt.hidden=true; }, 1800);} };
    if (navigator.clipboard) navigator.clipboard.writeText(c).then(show).catch(function(){});
    else { var ta=document.createElement('textarea'); ta.value=c; document.body.appendChild(ta); ta.select(); try{document.execCommand('copy'); show();}catch(_){} document.body.removeChild(ta); }
  });

  // ============ CONTINUE SHOPPING (close modal) ============
  document.addEventListener('click', function (e) {
    var cta = e.target.closest('.newsletter-popup__success-cta[data-eys-close-modal="1"]'); if (!cta) return;
    e.preventDefault();
    var x = document.querySelector('.tingle-modal__close'); if (x) x.click();
  });
})();